import $ from 'jquery';
import 'slick-carousel';
import AOS from "aos";


$(function () {
	'use strict';

	// Slick sliders

	$('#related-slider').on('init', function (event, slick) {
		// console.log("initialized");
		AOS.init();

	});
	$('#related-slider').slick({
		arrows: true,
		prevArrow: '<i class="far fa-chevron-circle-left"></i>',
		nextArrow: '<i class="far fa-chevron-circle-right"></i>',
		slidesToShow: 3,
		slidesToScroll: 1,
		adaptiveHeight: true,
		responsive: [
			{
				breakpoint: 769,
				settings: {
					slidesToShow: 2
				},

			},
			{
				breakpoint: 620,
				settings: {
					slidesToShow: 1
				},

			},

		]

	});
});
